import axios from 'axios'
import Vue from 'vue'
import store from '@/store/store.js'
import {
	Message
} from 'element-ui'
const http = {}
let url = Glod.BaseUrl;
var instance = axios.create({
	timeout: 100000,
	baseURL: url,
	headers: {
		'Content-Type': 'application/json;charset=UTF-8'
	},
	validateStatus(status) {
		return cusStatus(status,'');
	}
})


let loading;
let isShow = true;
let needLoadingRequestCount = 0 // 声明一个对象用于存储请求个数
function startLoading() {
	loading = Vue.prototype.$loading({
		lock: true,
		text: '努力加载中...',
		background: 'rgba(0,0,0,0.5)',
		target: document.querySelector('.content-container') // 设置加载动画区域
	})
}

function endLoading() {
	if (isShow == true)
		loading.close();
}

function showFullScreenLoading() {
	if (needLoadingRequestCount === 0) {
		startLoading()  
	}
	needLoadingRequestCount++
}

function hideFullScreenLoading() {
	if (needLoadingRequestCount <= 0) return
	needLoadingRequestCount--
	if (needLoadingRequestCount === 0) {
		endLoading()
	}
}

function cusStatus(status,txt) {
		switch (status) {
			case 400:
				Message.error(txt+"；状态码400")
				break
			case 401:
				Message.warning({
					message: '授权失败，请重新登录：'+txt
				})
				localStorage.removeItem('user');
				localStorage.removeItem('token');
				location.href = "/login";
				return
			case 403:
				Message.warning({
					message: '拒绝访问'
				})
				break
			case 405:
				Message.warning({
					message: '访问权限限制，请联系管理员'
				})
				break
			case 500:
				Message.warning({
					message: txt+"；状态码500"
				})
				break
		}
		// return true;
		return status >= 200 && status < 300;
	}

// 添加请求拦截器
instance.interceptors.request.use(
	function(config) {
		let token = localStorage.getItem('token');
		config.headers['Access-Control-Allow-Origin: *']; //允许所有域名的脚本访问该资源。
		config.headers[
			"Access-Control-Allow-Headers: token,Origin, X-Requested-With, Content-Type, Accept"
		]; //表明允许跨域请求包含content-type头
		config.headers['Access-Control-Allow-Methods: POST,GET']; //请求方式
		// 请求头添加token
		if (token) {
			config.headers.Authorization = "Bearer "+token;
			localStorage.setItem('token', token, 1800000);
		}
		if (isShow == true)
			showFullScreenLoading();
		return config
	},
	function(error) {
		hideFullScreenLoading();
		return Promise.reject(error)
	}
)

// 响应拦截器即异常处理
instance.interceptors.response.use(
	response => {
		hideFullScreenLoading();
		let rv = cusStatus(response.data.statusCode,response.data.msg);
		if(rv)
			return response.data
		else{
			return Promise.reject(response.data.msg);
		}
	},
	error => {
		hideFullScreenLoading();
		return Promise.reject(error);
	}
	);


http.get = function(url, options) {
	isShow = true;
	if (options != undefined && options.isload != undefined)
		isShow = options.isload;
	return new Promise((resolve, reject) => {
		instance
			.get(url, options)
			.then(response => {
				if (response.statusCode === 200) {
					resolve({
						data: response
					})
				} else {
					reject(response.msg)
				}
			})
			.catch(err => {
				console.log("error", "接口调用出错:" + url + err)
			})
	})
}

http.post = function(url, data, options) {
	isShow = true;
	if (options != undefined && options.isload != undefined)
		isShow = options.isload;
	return new Promise((resolve, reject) => {
		instance
			.post(url, data, options)
			.then(response => {
				hideFullScreenLoading();
				if (response.statusCode === 200) {
					resolve({
						data: response
					})
				} else {
					reject(response.msg)
				}
			})
			.catch(error => {
				console.log("error", "接口调用出错：url" + url + "" + error)
			})
	})
}

http.getOther = function(url, options) {
	isShow = false;
	return new Promise((resolve, reject) => {
		instance
			.get(url, options)
			.then(response => {
				resolve(response)
			})
			.catch(err => {
				console.log("error", "接口调用出错：url" + url + err)
			})
	})
}

http.postOther = function(url, data, options) {
	isShow = false;
	return new Promise((resolve, reject) => {
		instance
			.post(url, data, options)
			.then(response => {
				resolve(response)
			})
			.catch(err => {
				console.log("error", "接口调用出错：url" + url + "" + err)
			})
	})
}

export default http



// WEBPACK FOOTER //
// ./src/config/httpConfig.js